import React, { createContext, useContext, useState, useEffect } from 'react';

const AuthContext = createContext(null);

export function AuthProvider({ children }) {
  const [user, setUser] = useState(null);
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    const checkLoginStatus = async () => {
      try {
        // Use the /api/fastapi proxy for FastAPI backend calls
        const response = await fetch('/api/fastapi/api/user/me', {
          credentials: 'include', // Important to send the session cookie
        });

        if (response.ok) {
          const userData = await response.json();
          setUser(userData);
        } else {
          setUser(null);
        }
      } catch (error)
      {
        console.error('Failed to fetch user status:', error);
        setUser(null);
      } finally {
        setIsLoading(false);
      }
    };

    checkLoginStatus();
  }, []);

  const login = () => {
    // Redirect to the backend's login endpoint via proxy
    window.location.href = '/api/fastapi/auth/login';
  };

  const logout = () => {
    // Redirect to the backend's logout endpoint via proxy
    window.location.href = '/api/fastapi/auth/logout';
  };

  return (
    <AuthContext.Provider value={{ user, isLoading, login, logout }}>
      {children}
    </AuthContext.Provider>
  );
}

export function useAuth() {
  return useContext(AuthContext);
}
